import styled from "styled-components";
import { Colors, GrayColors } from "@smartsuite/types";

export const StyledSection = styled.div`
  gap: 15px;
  padding: 6px 15px;
  margin-bottom: 18px;
  border-radius: 8px;
  display: flex;
  min-height: 54px;
  background: ${Colors.dwRed};
  align-items: center;

  div:last-child {
    margin-left: auto;
  }
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-items: left;
  gap: 5px;
  color: ${Colors.dRed};
`;

export const MessageItem = styled.span`
  display: flex;
  font-size: 13px;
  word-break: break-word;
`;

export const BtnContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;

  background: ${Colors.custom1};

  margin-left: 10px;
  height: 28px;
  border: 1px solid ${GrayColors["G-1-5"]};
  padding: 6px 10px;

  border-radius: 5px;
  cursor: pointer;
  white-space: nowrap;
  transition: border-color 100ms ease-out;

  &:hover {
    transition: border-color 200ms ease-in;
    border-color: ${GrayColors["G-3"]};
  }

  span {
    color: ${Colors.custom15};
    font-weight: 600;
  }
`;
